type SearchParamsReader = Pick<URLSearchParams, 'get' | 'toString'>;

export const WORKSPACE_URL_CHANGE_EVENT = 'attune:workspace-url-change';

export function getPostHogPageviewTrackingKey(
  pathname: string,
  searchParams: SearchParamsReader | null | undefined
): string {
  const search = searchParams?.toString() || '';
  if (pathname !== '/app/workspace') return `${pathname}?${search}`;

  const mode = searchParams?.get('mode') || 'chat';
  const tab = searchParams?.get('tab');
  const pluginTab = searchParams?.get('pluginTab');
  const workspaceState = new URLSearchParams({ mode });
  if (
    (mode === 'tasks' &&
      (tab === 'approvals' || tab === 'activity' || tab === 'measuring' || tab === 'completed')) ||
    (mode === 'agents' && (tab === 'runs' || tab === 'templates'))
  ) {
    workspaceState.set('tab', tab);
  }
  if (mode === 'integrations' && pluginTab === 'skills') {
    workspaceState.set('pluginTab', pluginTab);
  }
  if (searchParams?.get('new_project') === 'true') workspaceState.set('new_project', 'true');
  if (searchParams?.get('onboarding_chat') === 'true') {
    workspaceState.set('onboarding_chat', 'true');
  }
  return `${pathname}?${workspaceState.toString()}`;
}
